export default __webpack_public_path__ + "static/suzuki2_img1-597f3dcb273986cd423b17bce7a3b608.jpg";